import ButtonDS from "get-life-storybook-ts/lib/atoms/ButtonDS/ButtonDS";
import CustomModal from "get-life-storybook-ts/lib/organisms/Modal/CustomModal";
import GlobalIcon from "../Icons/GlobalIcon";
import Input from "get-life-storybook-ts/lib/atoms/Input/Input";
import React, { useState } from "react";

type PhoneValidationStates = "validationCode" | "phoneNumber";

interface PhoneValidationModal {
  modalRef: React.MutableRefObject<any>;
  phoneValue: string;
  phoneOnBlur: () => null;
  PhoneOnValueChange: (e: any) => null;
  phoneError: { error: boolean; message: string } | undefined;
  RegeneratePhoneValidationCode: () => null;
  ValidatePhoneValidationCode: (code: string) => null;
}

const PhoneValidationModal = ({
  modalRef,
  phoneValue,
  phoneOnBlur,
  PhoneOnValueChange,
  phoneError,
  GeneratePhoneValidationCode,
  ValidatePhoneValidationCode,
}: any) => {
  const [state, setState] = useState<PhoneValidationStates>("validationCode");
  const [code, setCode] = useState<string>("");
  const [codeError, setCodeError] = useState<{
    error: boolean;
    message: string;
  }>({ error: false, message: "" });
  const [loading, setLoading] = useState<boolean>(false);

  const SwitchToPhoneNumberState = () => setState("phoneNumber");

  const SwitchToValidationCodeState = () => setState("validationCode");

  const ConfirmNewPhoneNumber = async () => {
    setLoading(true);
    await GeneratePhoneValidationCode();
    setLoading(false);
    SwitchToValidationCodeState();
  };

  const ValidateCode = async () => {
    setLoading(true);
    const ValideCodeError = await ValidatePhoneValidationCode(code);
    setCodeError(ValideCodeError);
    setLoading(false);
  };

  const GenerateANewPhoneValidationCode = async () => {
    if (loading) return;
    setLoading(true);
    await GeneratePhoneValidationCode();
    setLoading(false);
  };

  const IsPhoneNumberButtonDisabled = () =>
    loading || (phoneError && phoneError.error === true);

  return (
    <CustomModal
      ref={modalRef}
      fitContent={true}
      classNameContent="w-[640px]"
      ModalTitle={
        <div className="H4 text-[#424242] font-bold flex flex-row items-start gap-[8px]">
          {state === "validationCode" && (
            <>
              <GlobalIcon
                iconName="DeviceMobileMessageIcon"
                size="XS"
                color="currentColor"
              />
              Código de verificación por SMS
            </>
          )}
          {state === "phoneNumber" && (
            <>
              <GlobalIcon
                iconName="DeviceMobile"
                size="XS"
                color="currentColor"
              />
              Cambio de número de teléfono
            </>
          )}
        </div>
      }
      classNameBody="p-[24px]"
      ModalBody={
        <>
          {state === "validationCode" && (
            <>
              <div className="flex flex-col gap-[16px]">
                <span className="BodyM font-normal text-[#424242]">
                  Te hemos enviado un SMS con un código de verificación,
                  introdúcelo aquí para continuar.
                </span>
                <div className="flex flex-col gap-[8px]">
                  <Input
                    initialValue={code}
                    inputMode="number"
                    pattern="\d*"
                    onValueChange={(e: any) => setCode(e)}
                    placeholder="Introduce aquí el código enviado"
                    iconName="DeviceMobileMessageIcon"
                    initialError={codeError}
                  />
                  <span className="BodyS text-[#8E8E8E] font-normal">
                    <GlobalIcon
                      iconName="InfoIcon"
                      size="XXS"
                      color="currentColor"
                      className="inline-block mr-[4px] mb-[4px]"
                    />
                    Si no te ha llegado el código, podemos reenviarlo,{" "}
                    <u
                      role="button"
                      tabIndex={0}
                      onClick={GenerateANewPhoneValidationCode}
                      onKeyDown={(e) => {
                        if (e.key === " " || e.key === "Enter") {
                          e.preventDefault();
                          GenerateANewPhoneValidationCode();
                        }
                      }}
                    >
                      volver a enviar el código de verificación.
                    </u>
                  </span>
                </div>
              </div>
              <div className="mt-[24px] flex flex-row flex-wrap gap-[8px] justify-center">
                <ButtonDS
                  label="Editar número de teléfono"
                  buttonType="secondary"
                  ghost={true}
                  leftIcon="EditIcon"
                  className="flex-1 max-w-[350px] whitespace-nowrap"
                  onClick={SwitchToPhoneNumberState}
                  disabled={loading}
                />
                <ButtonDS
                  label="Continuar"
                  rightIcon="ArrowRightIcon"
                  className="flex-1 max-w-[350px] whitespace-nowrap"
                  onClick={ValidateCode}
                  disabled={loading}
                />
              </div>
            </>
          )}
          {state === "phoneNumber" && (
            <>
              <div className="flex flex-col gap-[16px]">
                <span className="BodyM font-normal text-[#424242]">
                  Escribe de nuevo tu número de teléfono
                </span>
                <div className="flex flex-col gap-[8px]">
                  <Input
                    initialValue={phoneValue}
                    inputMode="number"
                    pattern="\d*"
                    onBlur={phoneOnBlur}
                    onValueChange={PhoneOnValueChange}
                    placeholder="Número de teléfono"
                    iconName="DeviceMobile"
                    initialError={phoneError}
                  />
                  <span className="BodyS text-[#8E8E8E] font-normal">
                    <GlobalIcon
                      iconName="InfoIcon"
                      size="XXS"
                      color="currentColor"
                      className="inline-block mr-[4px] mb-[4px]"
                    />
                    Revisa, recuerda que luego te enviaremos un SMS de
                    confirmación.
                  </span>
                </div>
              </div>
              <div className="mt-[24px] flex flex-row flex-wrap gap-[8px] justify-center">
                <ButtonDS
                  label="Confirmar número"
                  leftIcon="CheckedIcon"
                  className="md:w-6/12 ml-auto whitespace-nowrap"
                  disabled={IsPhoneNumberButtonDisabled()}
                  onClick={ConfirmNewPhoneNumber}
                />
              </div>
            </>
          )}
        </>
      }
    />
  );
};

export default PhoneValidationModal;
